import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const spireApiOptionsTag = {
	type: ApiTag.IntegrationsSpire,
	id: "options"
} as const
export const spireAllImportRecordsTag = {
	type: ApiTag.IntegrationsSpire,
	id: "record/all"
} as const
export const spireAllImportResponsesTag = {
	type: ApiTag.IntegrationsSpire,
	id: "response/all"
} as const

export const spireAllTestApiRecords = {
	type: ApiTag.IntegrationsSpire,
	id: "testapi/records/all"
} as const

const spireIntegrationEndpoints = (build: McoEndpointBuilder) => ({
	integrationSpireReplaceApiResponse: build.mutation({
		queryFn: apiClient.integration.spire.replayApiResponse,
		invalidatesTags: [
			ApiTag.Patient,
			ApiTag.PatientCondition,
			spireAllImportResponsesTag
		]
	}),
	integrationSpireGetApiOptions: build.query({
		queryFn: (_: void) => apiClient.integration.spire.getApiOptions(),
		providesTags: [
			ApiTag.Tenant,
			ApiTag.Integrations,
			ApiTag.IntegrationsSpire,
			spireApiOptionsTag
		]
	}),
	integrationSpireTestUpdateWorkerPullUpToYesterday: build.mutation({
		queryFn: (setting: boolean) =>
			apiClient.integration.spire.updateTestOptionWorkerPullUpToYesterday(
				setting
			),
		invalidatesTags: [spireApiOptionsTag]
	}),
	integrationSpireGetImportRecords: build.query({
		queryFn: (request: { pageSize: number; pageIndex: number }) =>
			apiClient.integration.spire.getImportRecords(request),
		providesTags: (result) => [
			ApiTag.Tenant,
			ApiTag.Integrations,
			ApiTag.IntegrationsSpire,
			...(result?.importRecords.map(
				(x) =>
					({
						type: ApiTag.IntegrationsSpire,
						id: `record/${x.recordId}`
					}) as const
			) ?? []),
			spireAllImportRecordsTag
		]
	}),
	integrationSpireGetApiResponses: build.query({
		queryFn: (request: { pageSize: number; pageIndex: number }) =>
			apiClient.integration.spire.getApiResponses(request),
		providesTags: (result) => [
			ApiTag.Tenant,
			ApiTag.Integrations,
			ApiTag.IntegrationsSpire,
			spireAllImportResponsesTag,
			...(result?.importApiResponses.map(
				(x) =>
					({
						type: ApiTag.IntegrationsSpire,
						id: `response/${x.requestName}`
					}) as const
			) ?? [])
		]
	}),
	integrationSpireDeleteAllApiResponses: build.mutation({
		queryFn: (_: void) =>
			apiClient.integration.spire.deleteAllApiResponses(),
		invalidatesTags: [spireAllImportResponsesTag]
	})
})

export default spireIntegrationEndpoints
